import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAuthTokensKey } from '../../utils/keys';
import { getNetworkKey } from '../../utils/keys/network.key';
export const useClearNewDomain = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation(() => client.network.clearNewDomain(), {
        onSettled: () => {
            const authTokenKey = getAuthTokensKey();
            const networkKey = getNetworkKey();
            queryClient.invalidateQueries(authTokenKey);
            queryClient.invalidateQueries(networkKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useClearNewDomain.js.map